var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "layout_closeButton__ZRUmo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.409 12l4.295-4.287a1.003 1.003 0 00-1.418-1.42L12 10.59 7.714 6.294a1.003 1.003 0 10-1.418 1.419l4.295 4.286-4.295 4.287a1 1 0 000 1.418 1 1 0 001.418 0L12 13.408l4.286 4.296a.998.998 0 001.418 0 1 1 0 000-1.418l-4.295-4.287z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.125b0036d38dac021bf9525caf33d992.svg";
export { ForwardRef as ReactComponent };